<template>
  <div>
    <div class="active-tasks" ref="cardActiveTask">
      <div class="active-tasks-title">
        <div>
          <h2>Tarefas em Execução</h2>
        </div>
        <div class="menu">
          <v-btn flat icon :disabled="first || itemsProp.length <= qtt" @click="updateData(-1)" color="black" style="margin: 0;">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <strong v-if="itemsLength === 0">0 - 0 de 0</strong>
          <strong v-else>{{((index) * qtt) + 1}} - {{(((index + 1) * qtt) < itemsLength) ? (index + 1) * qtt : itemsLength}} de {{itemsLength}}</strong>
          <v-btn flat icon :disabled="last || itemsProp.length <= qtt" @click="updateData(1)" color="black" style="margin: 0;">
            <v-icon>arrow_forward</v-icon>
          </v-btn>
        </div>
        <v-tooltip top>
          <v-icon slot="activator" color="black" size="20px">{{'info'}}</v-icon>
          <span class="dica">Mostra todas as tarefas que estão sendo realizadas neste momento.</span>
        </v-tooltip>
      </div>
      <div class="center content" v-if="loading">
        <img class="loader" :src="`${basePath}images/loader.gif`" width="100px" />
      </div>
      <div v-else-if="items.length > 0" class="content">
        <div class="item" v-for="item in items" :key="item.id">
          <div class="image">
            <div v-if="item.user_name != 'Sem Responsável'">
              <v-tooltip top>
                <img slot="activator" v-if="item.photo" class="mr-2 item-user" :src="`${basePath}uploads/users/${item.photo}`" alt="avatar">
                <div slot="activator" class="usuario" v-else>
                  <h3>{{getFirstLetters(item.user_name)}}</h3>
                </div>
                <span>{{item.user_name || 'Sem Responsável'}}</span>
              </v-tooltip>
            </div>
            <div v-else>
              <v-tooltip top>
                <v-avatar slot="activator" size="50px" color="#00acc2" class="avatar">
                  <v-icon size="35px" color="white">person</v-icon>
                </v-avatar>
                <span>{{item.user_name || 'Sem Responsável'}}</span>
              </v-tooltip>
            </div>
          </div>
          <div class="client" v-if="item.client">
            <v-chip outline small>
              <v-avatar v-if="item.client.auto && item.client.connection_company && item.client.connection_company.logo_path">
                <img :src="`${basePath}uploads/companies/${item.client.connection_company.logo_path}`" alt="a23vatar">
              </v-avatar>
              <v-avatar v-else-if="!item.client.auto && item.client.logo_path">
                <img :src="`${basePath}uploads/connections/${item.client.logo_path}`" alt="a23vatar">
              </v-avatar>
              <v-avatar v-else class="avatar">
                <span class="avatar-letters"> {{ getFirstLetters(item.client.id_text) }} </span>
              </v-avatar>
              <span class="align-left">{{item.client.id_text | formatAbbreviation(20)}}</span>
            </v-chip>
          </div>
          <div style="width: 100%">
            <v-tooltip bottom>
              <router-link v-if="checkPermission('tasks', 'manage')" slot="activator" :to="`/task/${item.id}?return=dashboard_movement`">
                <span class="task-description mx-2" :style="'overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; word-break: break-all;'+(item.client ? 'margin-bottom: 25px;' : '')">{{(item.identifier + ' - ' + item.task_name) }}</span>
              </router-link>
              <span v-else class="task-description mx-2" :style="'overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; word-break: break-all;'+(item.client ? 'margin-bottom: 25px;' : '')" slot="activator">{{(item.identifier + ' - ' + item.task_name) }}</span>
              <span><p-entire-field :field="item.task_name"></p-entire-field></span>
            </v-tooltip>
          </div>
          <v-chip label disabled style="border: 1px solid #00acc2; flex: 0;" text-color="#00acc2" color="#fff">{{calculateTime(item.begin)}}</v-chip>
        </div>
      </div>
      <div class="content" v-else>
        <span class="no-data">Não possui registros</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .active-tasks {
    background: #00acc2;
    padding: 2px;
    /* height: 347px; */
    height: 424px;
  }

  .menu {
    position: relative;
  }

  .active-tasks-title {
    padding-left: 5px;
    color: #fff;
    display: flex;
    justify-content: space-between;
  }

  .item span {
    flex: 1;
  }

  .align-left {
    align-items: left;
  }

  .client {
    position: absolute;
    left: 65px;
    bottom: -3px;
  }
  .content {
    background: #fff;
    padding: 0 8px;
    display: flex;
    flex-direction: column;
    /* height: 304px; */
    height: 381px;
  }

  .no-data {
    background: #fff;
    height: 304px;
    flex-direction: column;
    justify-content: center;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #00acc2;
    padding: 5px 0;
    height: 77px;
    position: relative;
  }

  .item:nth-of-type(5) {
    border-bottom: none;
  }

  .item .usuario {
    color: #fff;
    background-color: #00acc2;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar {
    background: linear-gradient(to right, #00F260 , #0575E6);
    color: #fff;
  }

  .avatar-letters {
    font-weight: bold;
    color: #fff;
    font-size: 0.9em;
  }

  .item .usuario h3 {
    font-size: 1.5em;
  }

  .item-user {
    height: 50px;
    width: 50px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }

  .item span.status {
    border: 1px solid #dc3545;
    display: inline-block;
    padding: 2px 6px;
    border-radius: 50%;
    font-size: 12px;
  }

  .item span.done {
    text-decoration: line-through;
  }

  .item span.outdated {
    color: #dc3545;
  }

  @media screen and (max-width: 800px) {
    .active-tasks-title {
      align-items: center;
    }

    .active-tasks-title h2 {
      font-size: 1.15em;
    }
  }

  @media screen and (min-width: 2500px) {
    /* .active-tasks {
      height: calc(50vh);
    }

    .content {
      height: calc(50vh - 64px);
    } */

    .active-tasks-title h2 {
      font-size: 2.5em;
    }

    .dica{
      font-size: 2em;
    }

    .task-description {
      font-size: 1.5em;
    }

    span.no-data {
      font-size: 2em;
    }
  }
</style>

<script>
  import PEntireField from './../../shared/PEntireField'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  import general from '../../../mixin/general'
  import access from '../../../mixin/access'

  momentDurationFormatSetup(moment)

  export default {
    props: ['itemsProp', 'loading'],
    components: {PEntireField},
    mixins: [general, access],
    data: () => ({
      timeInterval: 0,
      itemInterval: 0,
      items: [],
      basePath: process.env.API,
      index: 0,
      first: false,
      last: false,
      qtt: 5,
      itemsLength: 0
    }),
    mounted () {
      this.createData()
      // SetInterval criado para atualizar os registros para o cronometro fos registros ficar correndo
      this.timeInterval = setInterval(() => {
        this.createData()
      }, 1000)
      this.itemInterval = setInterval(() => {
        if ((this.index + 1) > (Math.ceil(this.itemsLength / this.qtt))) {
          this.index = 0
          this.createData()
        }
        if (document.fullscreenElement) {
          if (Math.ceil(this.itemsLength / this.qtt) !== 0) { this.updateData(((this.index + 1) >= Math.ceil(this.itemsLength / this.qtt)) ? -this.index : 1) }
        }
      }, 10000)
    },
    destroyed () {
      clearInterval(this.timeInterval)
      clearInterval(this.itemInterval)
    },
    methods: {
      createData: function (i = this.index) {
        this.items = []
        Object.assign(this.items, this.itemsProp)
        this.index = i
        this.itemsLength = this.items.length
        this.items = this.items.splice(this.index * this.qtt, this.qtt)
        this.last = ((this.index + 1) === (Math.ceil(this.itemsLength / this.qtt)))
        this.first = (this.index === 0)
      },
      updateData (i) {
        Object.assign(this.items, this.itemsProp || [])
        this.index = this.index + i
        this.items = this.items.splice(this.index * this.qtt, this.qtt)
        this.last = ((this.index + 1) === (Math.ceil(this.itemsLength / this.qtt)))
        this.first = (this.index === 0)
      },
      calculateTime: function (begin) {
        return moment.duration(moment().diff(begin)).format('HH:mm:ss')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/cards/CardMovementsActiveTasks.vue